module.exports = __webpack_public_path__ + "img/title-w.fdb4955e.svg";